var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f4155750-9b1a-417b-ba46-48f1e5f8f608",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 699.1 386.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e30c5d7f-22e7-4f2a-893f-ac86285176c5",
    x1: 0,
    y1: -6080.07,
    x2: 699.1,
    y2: -6080.07,
    gradientTransform: "translate(0 -5886.58) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a7df0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#1875f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#3f60f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#7d3ff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b721ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-b0cab881-5dcf-4f82-a959-bbb9571bdd41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m193.48,0c42.32,0,81.47,13.6,113.32,36.66l-31.82,70.59c-21.26-20.1-49.94-32.42-81.5-32.42-65.54,0-118.66,53.13-118.66,118.66s53.13,118.66,118.66,118.66c52.46,0,96.97-34.05,112.64-81.25h-112.64v-74.82h122.29C333.2,67.13,411.57,0,505.62,0c106.86,0,193.48,86.62,193.48,193.48s-86.62,193.48-193.48,193.48c-49.11,0-93.95-18.31-128.06-48.46,16.05-20.35,28.8-43.43,37.45-68.42,21.77,25.72,54.28,42.06,90.62,42.06,65.54,0,118.66-53.13,118.66-118.66s-53.13-118.66-118.66-118.66-118,50.27-118.75,112.63c3.35,109.11-84.1,199.51-193.39,199.51S0,300.34,0,193.48,86.63,0,193.48,0",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-ae786abb-589c-4c33-b207-93937872c578",
    x1: -5.05,
    y1: -6335.04,
    x2: 474.18,
    y2: -5990.45,
    xlinkHref: "#uuid-e30c5d7f-22e7-4f2a-893f-ac86285176c5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-15f4c83a-11a8-4df9-bd1d-0e9dbf7ef03a"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-d37cbd89-3a5e-4b15-9d8b-0deadaa1117f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m193.48,0c42.32,0,81.47,13.6,113.32,36.66l-31.82,70.59c-21.26-20.1-49.94-32.42-81.5-32.42-65.54,0-118.66,53.13-118.66,118.66s53.13,118.66,118.66,118.66c52.46,0,96.97-34.05,112.64-81.25h-112.64v-74.82h122.29C333.2,67.13,411.57,0,505.62,0c106.86,0,193.48,86.62,193.48,193.48s-86.62,193.48-193.48,193.48c-49.11,0-93.95-18.31-128.06-48.46,16.05-20.35,28.8-43.43,37.45-68.42,21.77,25.72,54.28,42.06,90.62,42.06,65.54,0,118.66-53.13,118.66-118.66s-53.13-118.66-118.66-118.66-118,50.27-118.75,112.63c3.35,109.11-84.1,199.51-193.39,199.51S0,300.34,0,193.48,86.63,0,193.48,0",
    fill: "url(#uuid-e30c5d7f-22e7-4f2a-893f-ac86285176c5)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uuid-b0cab881-5dcf-4f82-a959-bbb9571bdd41)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 699.11,
    height: 386.96,
    fill: "url(#uuid-ae786abb-589c-4c33-b207-93937872c578)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoLogo);
export default __webpack_public_path__ + "static/media/Go_logo.985be419251b533664253a90f1d7a859.svg";
export { ForwardRef as ReactComponent };